var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleCheckedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    transform: "rotate(-180 12 12)",
    fill: "#36BC69"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2477 14.4534L8.20601 12.4117C8.15262 12.3577 8.08903 12.3148 8.01894 12.2855C7.94885 12.2562 7.87364 12.2411 7.79767 12.2411C7.72171 12.2411 7.6465 12.2562 7.57641 12.2855C7.50631 12.3148 7.44273 12.3577 7.38934 12.4117C7.3353 12.4651 7.29239 12.5287 7.26311 12.5988C7.23383 12.6689 7.21875 12.7441 7.21875 12.8201C7.21875 12.896 7.23383 12.9712 7.26311 13.0413C7.29239 13.1114 7.3353 13.175 7.38934 13.2284L9.83351 15.6726C10.061 15.9001 10.4285 15.9001 10.656 15.6726L16.8393 9.49507C16.8934 9.44168 16.9363 9.3781 16.9656 9.308C16.9949 9.23791 17.0099 9.1627 17.0099 9.08674C17.0099 9.01077 16.9949 8.93556 16.9656 8.86547C16.9363 8.79537 16.8934 8.73179 16.8393 8.6784C16.786 8.62436 16.7224 8.58146 16.6523 8.55217C16.5822 8.52289 16.507 8.50781 16.431 8.50781C16.355 8.50781 16.2798 8.52289 16.2097 8.55217C16.1396 8.58146 16.0761 8.62436 16.0227 8.6784L10.2477 14.4534Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckedIcon);
export default __webpack_public_path__ + "static/media/circleCheckedIcon.d2e28fbeada34f317ec209d6b1a75530.svg";
export { ForwardRef as ReactComponent };